/// <reference types="vite/client" />
/**
 * The Mossy Ruins example, bundled with the site as a starting point for new
 * projects. Its files are built as assets and fetched when someone picks it;
 * its code (the game page and scripts) is built in as text.
 */
const urls = import.meta.glob(['../../../examples/ruins/project.json', '../../../examples/ruins/public/**/*'], {
  query: '?url',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const code = import.meta.glob(['../../../examples/ruins/index.html', '../../../examples/ruins/src/**/*'], {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const prefix = '../../../examples/ruins/';
const encoder = new TextEncoder();

export async function exampleProject(): Promise<Map<string, Uint8Array>> {
  const entries = await Promise.all(
    Object.entries(urls).map(async ([path, url]) => {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Could not load the example's ${path.slice(prefix.length)}`);
      return [path.slice(prefix.length), new Uint8Array(await res.arrayBuffer())] as const;
    }),
  );
  const files = new Map<string, Uint8Array>(entries);
  for (const [path, text] of Object.entries(code)) files.set(path.slice(prefix.length), encoder.encode(text));
  return files;
}
